import {
  //   ApiGetRequest,
  ApiPostRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Laporan Buku Besar',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Laporan Buku Besar',
        href: '/adm/fin/laporan/buku-besar',
        active: true,
      },
    ],
    form: {
      periode: '',
      tipe_akun: '1',
    },
    report: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeBukuBesar(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getBukuBesar({ commit, state }) {
    commit('changeBukuBesar', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`fin/laporan/buku-besar`, data.form);
    commit('changeBukuBesar', {
      report: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },
};
